module.exports = __webpack_public_path__ + "img/cert20.f60872ea.png";